import React, { useState, useEffect } from "react";
import { Table, Card, Button, Space, Form, Input, Switch, Select, Col, Row, Modal, message, Descriptions, Spin } from 'antd';
import { ZoomInOutlined, SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import XLSX from 'xlsx'
import Highlighter from "react-highlight-words";
import Axios from "axios";
import config from "../../config";
import { usePersistedStore } from "../../store/persisted-store";
import { useNonePersistedStore } from "../../store/non-persisted-store";

const ReceiptsReport = () => {
    const { auth, business } = usePersistedStore();
    const { getSupportReport, receipts } = useNonePersistedStore()
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const businessToken = business.currentBusiness.token;
    const userToken = auth.userToken;
    const data = receipts.filtered;
    const loading = receipts.loading;
    const currentBusiness = business.currentBusiness;
    const userInfoResources = auth.userInfo.Resources;
    const [, setRequestId] = useState();
    const [filterData, setFilterData] = useState([]);
    const [statusTitleInfo, setStatusTitleInfo] = useState(false);
    const [searchedColumn, setSearchedColumn] = useState('');
    const [searchText, setSearchText] = useState('');
    const receiptTypeFilter = [...new Set(data?.map(item => item.ReceiptType))];
    const { token } = currentBusiness;

    const [visible, setVisible] = useState(false);
    const [details, setDetails] = useState();
    const [srvLoading, setSrvLoading] = useState(false);

    useEffect(() => {
        if (!token)
            navigate('/dashboard');
        getSupportReport();
    }, [navigate, token])

    useEffect(() => {
        setFilterData(data)
    }, [data]);

    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}>
                        جستجو
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>ریست</Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (text),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const handleDataChange = (statusTitleInfo) => {
        if (statusTitleInfo) {
            const information = filterData?.filter(row => row.StatusTitle === "پرداخت شده");
            setFilterData(information)

        } else {
            setFilterData(data)
        }
        setStatusTitleInfo(statusTitleInfo);
    };

    const typeFilter = (type) => {
        setStatusTitleInfo(false)
        if (type === null) {
            setFilterData(data)
        } else {
            const reciptTypeName = data.filter(receiptType => receiptType.ReceiptType.includes(type))
            setFilterData(reciptTypeName)
        }
    };

    function downloadxlsx() {
        let evaluator = filterData ? filterData : data;
        if (!data) return
        let xlsxData = evaluator?.map(d => {
            return [
                d.ReceiptId,
                d.ReceiptType,
                d.Amount,
                d.SumPayment,
                d.Wallet,
                d.StatusTitle,
                d.ContradictionAmount,
                d.DebitUserId,
                d.DebitUserFullName,
                d.TrackingCode,
                d?.CreationTime ? strings.getFarsiNum(moment(d.CreationTime).format('jYYYY/jMM/jDD HH:mm')) : "",
                d.Description
            ]
        }
        );
        xlsxData.unshift(['آی دی', "نوع فاکتور", 'مبلغ کل', 'مبلغ پرداختی', "کیف پول", 'وضعیت', 'مغایرت', 'آی دی پرداخت کننده', 'پرداخت کننده', 'کد پیگیری', 'تاریخ ایجاد', 'توضیحات'])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "receiptSupportReport.xlsx")
    }

    function onfinish(values) {
        let { branch, search, company, info } = values;
        if (info) info = "تکمیل اطلاعات"

        let array = [];
        const filtered = data && data.filter((item, index) => {
            // quering for search input field
            if ((search ? item.FullName.includes(search) ||
                item.UserName.includes(search) ||
                item.InsuranceRequestId.toString().includes(search) ||
                item.InsuranceTypeName.includes(search) || item.CompanyName.includes(search) ||
                item.TrackingCode.includes(Number(search)) : true)

                && (company ? item.CompanyName.includes(company) : true)
                && (branch ? item.InsuranceTypeName.includes(branch) : true)
                && (info ? item.StatusTitle == info : true)) {
                array.push(item);
                return array
            }
        })
    }

    const columns = [
        {
            title: "جزئیات",
            dataIndex: "operation",
            key: "operation",
            width: 85,
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            getDetails(record.Id);
                            setRequestId(record.Id);
                            setVisible(true);
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: "آی دی",
            dataIndex: "ReceiptId",
            key: "ReceiptId",
            ...getColumnSearchProps('ReceiptId', 'آی دی'),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "نوع فاکتور",
            dataIndex: "ReceiptType",
            key: "ReceiptType",
            ...getColumnSearchProps('ReceiptType', 'نوع'),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "مبلغ کل",
            dataIndex: "Amount",
            key: "Amount",
            ...getColumnSearchProps('Amount', 'مبلغ کل'),
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مبلغ پرداختی",
            dataIndex: "SumPayment",
            key: "SumPayment",
            ...getColumnSearchProps('SumPayment', 'مبلغ پرداختی'),
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "کیف پول",
            dataIndex: "Wallet",
            key: "Wallet",
            ...getColumnSearchProps('Wallet', 'کیف پول'),
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "وضعیت پرداخت",
            dataIndex: "StatusTitle",
            key: "StatusTitle",
            ...getColumnSearchProps('StatusTitle', 'وضعیت پرداخت')
        },
        {
            title: "مغایرت",
            dataIndex: "ContradictionAmount",
            key: "ContradictionAmount",
            ...getColumnSearchProps('ContradictionAmount', 'مغایرت'),
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        // {
        //     title: "آی دی پرداخت کننده",
        //     dataIndex: "DebitUserId",
        //     key: "DebitUserId",
        //     colSpan: 1,
        //     ...getColumnSearchProps('DebitUserId', 'پرداخت کننده'),
        //     render: data => strings.getFarsiNum(data)
        // },
        {
            title: "پرداخت کننده",
            dataIndex: "DebitUsername",
            key: "DebitUsername",
            ...getColumnSearchProps('DebitUsername', 'پرداخت کننده'),
            render: data => strings.getFarsiNum(data)
        },
        {
            title: "کد پیگیری",
            dataIndex: "TrackingCode",
            key: "TrackingCode",
            ...getColumnSearchProps('TrackingCode', 'مبلغ'),
            render: data => data
        },
        {
            title: 'تاریخ ایجاد',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            sorter: (a, b) => new Date(a.CreationTime) - new Date(b.CreationTime),
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD HH:mm'))
        },
        {
            title: "توضیحات",
            dataIndex: "Description",
            key: "Description",
            ...getColumnSearchProps('Description', 'کد پرداخت')
        },
    ];


    const getDetails = (id) => {
        try {
            setSrvLoading(true);
            Axios({
                method: "GET",
                baseURL: config.apiUrls(),
                url: `v1/payment/receipt/${id}/Info`,
                headers: { "token": businessToken, Authorization: `Bearer ${userToken}` }
            }).then((response) => {
                setDetails(response.data.Details);
                setSrvLoading(false);
            })
        } catch (error) {
            setSrvLoading(false);
            setDetails(null);
            message.error(error.Message)
        }
    }

    return (
        <Card>
            <div className="alert alert-warning alert-dismissible fade show" role="alert" style={{ padding: "15px" }}>
                <i className="mdi mdi-alert-outline mr-2"></i> اطلاعات ذیل مربوط به پانزده روز گذشته می باشند.
                <div style={{ float: "left" }}>
                    <button
                        style={{ position: "relative", bottom: 6, }}
                        type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit"
                        onClick={() => {
                            getSupportReport()
                            form.resetFields();
                        }}>
                        بروزرسانی لیست &nbsp;&nbsp;&nbsp;<i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>
                    </button>
                </div>
            </div>
            <Form
                form={form}
                onFinish={onfinish}
                layout="inline"
                className="components-table-demo-control-bar"
                style={{ marginBottom: 16 }}
            >
                <Row gutter={[16, 8]} justify="space-around" align="middle">
                    <Col xs={10}>
                        <Form.Item
                            label={<>فیلتر بر اساس نوع فاکتور</>}
                            name="company">
                            <Select
                                defaultValue={null}
                                className="BusinessSupport-filter"
                                onChange={typeFilter}
                                placeholder="نام شرکت">
                                <Select.Option value={null}>همه فاکتورها</Select.Option>
                                {receiptTypeFilter.length && receiptTypeFilter.map((name, index) => {
                                    return <Select.Option key={index} value={name}>{name}</Select.Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col className="d-flex align-items-center" xs={6}>

                        <Form.Item name="info" label="نمایش فقط پرداخت شده">
                            <Switch defaultChecked={false} checked={statusTitleInfo}
                                onChange={handleDataChange}
                            />
                        </Form.Item>
                    </Col>
                    <Col style={{ marginRight: "auto", marginLeft: 18 }} xs={5}>
                        <div style={{ whiteSpace: "nowrap" }}>
                            {userInfoResources && userInfoResources?.includes("BusinessAdmin") && <div style={{ cursor: "pointer" }} onClick={downloadxlsx} className="btn-success border-0 rounded ml-auto pb-2 pt-2 pr-3 pl-3 mr-2 mb-2"> <i className="far fa-file-excel font-size-14 align-middle mr-2"></i>دریافت اکسل</div>}

                            {/* <button
                                disabled={load} type="primary" className="btn btn-primary waves-effect waves-light" style={{ marginLeft: 12 }} htmltype="submit">
                                <i className={`${load ? "bx bx-loader bx-spin" : "fas fa-search"} font-size-14 align-middle mr-2`}></i>اعمال فیلتر
                            </button> */}
                        </div>
                    </Col>
                </Row>
            </Form>
            <Table
                style={{ overflowX: 'scroll', width: "100%" }}
                bordered
                dataSource={[...filterData] && [...filterData]}
                loading={loading}
                rowKey="ReceiptId"
                scroll={true}
                columns={userInfoResources &&
                    (userInfoResources.includes("BusinessSaleReport") ||
                        userInfoResources.includes("BusinessSupportReport")) ?
                    columns : (columns.filter(col => col.dataIndex !== 'operation'))}
                className="custom-table"
            />
            {/* <InsuranceDetails requestId={requestId} /> */}

            <Modal
                width={900}
                title="جزئیات فاکتور"
                className="custom-table"
                visible={visible}
                footer={false}
                onCancel={() => setVisible(false)}>
                <Spin spinning={srvLoading}>
                    <Row>
                        {details?.length > 0 && details?.map((item, index) => {
                            return <Col span={8}>
                                <Descriptions key={index}>
                                    <Descriptions.Item label={item.Title} className="font-bold">
                                        {item.Value}
                                    </Descriptions.Item>
                                </Descriptions>
                            </Col>
                        })}
                    </Row>
                </Spin>
            </Modal>
        </Card>
    )
}

export default ReceiptsReport